import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCtaSection() {
  return <section className="relative py-20 md:py-28 bg-gradient-to-b from-navy to-navy-dark overflow-hidden" data-id="element-87">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
      backgroundSize: '40px 40px'
    }} data-id="element-88" />

      <div className="max-w-[1200px] mx-auto px-6 md:px-12 relative z-10" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.9,
        ease: 'easeOut'
      }} className="max-w-[800px] mx-auto text-center relative" data-id="element-90">
          {/* Decorative gold corner marks around content */}
          <div className="absolute -top-8 -left-8 w-16 h-16 border-t-[1.5px] border-l-[1.5px] border-gold/30 hidden md:block" data-id="element-91" />
          <div className="absolute -bottom-8 -right-8 w-16 h-16 border-b-[1.5px] border-r-[1.5px] border-gold/30 hidden md:block" data-id="element-92" />

          <div className="w-16 h-[2px] bg-gold mx-auto mb-10" data-id="element-93" />

          <h2 className="text-white text-[32px] md:text-[44px] leading-[1.15] mb-8 tracking-[-0.02em]" data-id="element-94">
            Who do you talk with when the stakes are high and the strategy is
            breaking down?
          </h2>

          <p className="text-warm-light text-[16px] md:text-[18px] leading-[1.75] mb-14 max-w-[660px] mx-auto" data-id="element-95">
            Leadership does not have to be lonely. The gap between strategy and
            execution closes when leaders have a space to think clearly, align
            people, and move from conversation to action. Whether you want a
            trusted thinking partner or want to develop coaching capability that
            multiplies leadership across your organization, the next step is a
            conversation.
          </p>

          <div className="flex flex-col items-center sm:flex-row gap-4 justify-center mb-8" data-id="element-96">
            <Button variant="white" className="w-full sm:w-auto" data-id="element-97">
              Schedule a Leadership Clarity Conversation
            </Button>
            <Button variant="transparent-white" className="w-full sm:w-auto" href="https://schallercoaching.com/lwca" data-id="element-98">
              Explore the Academy
            </Button>
          </div>

          <p className="text-warm-light/60 text-[14px] tracking-wide" data-id="element-99">
            Confidential. No pressure. A real leadership conversation.
          </p>
        </motion.div>
      </div>
    </section>;
}